import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "border position-relative h-100",
    style: { "overflow": "hidden" }
};
const _hoisted_2 = {
    ref: "editor",
    style: { "position": "absolute", "left": "0", "top": "0", "width": "100%", "height": "100%", "max-height": "100% !important", "margin": "0", "padding": "0", "overflow": "hidden" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, null, 512)
    ]));
}
